import { Connection as PortalConnection } from 'portal-sdk';

import { Permission } from 'src/constants/permissions';

export const enum ConnectionStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  SIGNED_OUT = 'SIGNED_OUT',
}

export enum ConnectionFailureReason {
  NO_RESPONSE = 'NO_RESPONSE',
}

export interface Connection extends PortalConnection {
  // username always exists
  username: string;
  // password could exist
  password?: string;
  token?: string;
  useBrowserAuth?: boolean;
}

/** convert a Portal Connection into a Designer Connection */
export const coercePortalConnection = (
  connection: PortalConnection
): Connection => ({
  ...connection,
  // assuming username is never undefined
  username: connection.username || '',
  // convert from `null | undefined` to just `undefined`
  token: connection.token || undefined,
  // turn `null` into `undefined`
  useBrowserAuth: connection.useBrowserAuth || undefined,
});

export type ConnectionsState = {
  catalogDatabaseByConnectionId: Record<string, string>;
  connection: Connection | null;
  failureReason: ConnectionFailureReason | null;
  pendingConnectToStardog: boolean;
  permissions: Permission[] | null;
  stardogVersionByConnectionId: Record<string, string | null>;
  status: ConnectionStatus | null;
};

export const createInitialConnectionsState = (): ConnectionsState => ({
  catalogDatabaseByConnectionId: {},
  connection: null,
  failureReason: null,
  pendingConnectToStardog: false,
  permissions: null,
  stardogVersionByConnectionId: {},
  status: null,
});
